import { render, staticRenderFns } from "./weikaipiaoCB.vue?vue&type=template&id=0b8221dd&scoped=true&"
import script from "./weikaipiaoCB.vue?vue&type=script&lang=js&"
export * from "./weikaipiaoCB.vue?vue&type=script&lang=js&"
import style0 from "./weikaipiaoCB.vue?vue&type=style&index=0&id=0b8221dd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8221dd",
  null
  
)

export default component.exports